'use client';

import { createContext, useContextSelector } from 'use-context-selector';

export type ActiveHostEntitiesContextType = {
  projectId: string | null;
  documentId: string | null;
  documentName: string | null;
  refetchActiveEntities: () => Promise<void>;
};

const defaultContext: ActiveHostEntitiesContextType = {
  projectId: null,
  documentId: null,
  documentName: null,
  refetchActiveEntities: () => Promise.resolve(),
};

export const ActiveHostEntitiesContext =
  createContext<ActiveHostEntitiesContextType>(defaultContext);

export const useActiveDocumentId = () =>
  useContextSelector(
    ActiveHostEntitiesContext,
    (context) => context.documentId
  );

export const useActiveDocumentName = () =>
  useContextSelector(
    ActiveHostEntitiesContext,
    (context) => context.documentName
  );

export const useActiveHostProjectId = () =>
  useContextSelector(ActiveHostEntitiesContext, (context) => context.projectId);

export const useRefetchActiveEntities = () =>
  useContextSelector(
    ActiveHostEntitiesContext,
    (context) => context.refetchActiveEntities
  );
